<template>
  <div class="CargoOrdersPublishing font12">
    <SpForm @submit="submit">
      <div class="content flex-jc-bt">
        <div class="flex-52 left-side">
          <sp-card type="none" custom-class="sp-color-bg-4">
            <div class="card-content">
              <div class="text-left">
                <sp-radio-group v-model="basicInfo.matchFilter" name="matchFilter" :cancelable="false" class="option">
                  <div class="flex-al-center pd-20 sp-color-bg-16">
                    <div class="flex-33">
                      <div v-triangle class="">{{ $l('ToWheretofindthemacthes') }}</div>
                      <div class="font12 fs-tip italic mg-l-10 pd-l-10" style="padding-right: 129px">{{ $l('Inthiswayyoucanfindmatchesamongallorpartialresourcesoftheplatform') }}</div>
                    </div>
                    <div class="flex-33">
                      <sp-radio label-position="right" :width="12" value="0">
                        <div class="pd-l-10">{{ $l('AllShipowners') }}</div>
                      </sp-radio>
                      <sp-radio label-position="right" :width="12" disabled value="-1" class="mg-t-10">
                        <div class="pd-l-10">{{ $l('SelectedShipowners') }}</div>
                      </sp-radio>
                      <sp-radio label-position="right" :width="12" disabled value="-1" class="mg-t-10">
                        <div class="pd-l-10">{{ $l('SearchAndFilterSomeShipowners') }}</div>
                      </sp-radio>
                    </div>
                    <div class="flex-33 flex-jc-end pd-l-50">
                      <SpButton type="warn" width="200" height="54" to="selectCharteringShipowners"> {{ $l('BrowseAllAndSelect') }} </SpButton>
                    </div>
                  </div>
                </sp-radio-group>
                <div class="three-dimensional">
                  <div class="top" />
                  <div class="flex-al-center">
                    <div class="left" />
                    <div class="flex-1" style="position:relative;">
                      <div class="flex-al-center pd-b-20 pd-l-20 pd-r-30 pd-t-20" style="background-color: rgba(246, 246, 246, 0.5); position:relative;">
                        <div class="flex-30">
                          <div v-triangle class="">{{ $l('CCBrokers') }}</div>
                          <div class="font12 fs-tip italic mg-l-10 pd-l-10 pd-r-20" style="">
                            <div>In line with the matching results,</div>
                            <div>we neeed their professional</div>
                            <div>(or value-added) services to</div>
                            <div>reach a deal</div>
                          </div>
                        </div>
                        <div class="flex-37" style="padding-top: 13px">
                          <sp-radio-group v-model="basicInfo.isAllBrokers" :cancelable="false" name="isAllBrokers" class="option">
                            <sp-radio :width="12" label-position="right" :value="1" :cancelable="false">
                              <div class="pd-l-10">{{ $l('AllCharteringBrokers') }}</div>
                            </sp-radio>

                            <div class="flex-al-center mg-t-10">
                              <div style="width: 28px">
                                <sp-radio :width="12" class="cusSpChoose no-label" disabled label-position="right" :value="2" label="" />
                              </div>
                              <div class="flex-1">
                                <SpSelect :pop-class="['sp-color-bd-1-solid-6 sp-color-bg-4','fs-int']"
                                          :text-style="{fontSize: '12px'}"
                                          style="position: relative; left: -8px"
                                          :disabled="basicInfo.isAllBroker === 1"
                                          multi-select
                                          name="brokerCorps"
                                          :options="basicInfo.brokerCompanyOptions"
                                          type="none"
                                          size="small"
                                          class="filter-select"
                                          :placeholder="$l('SelectedChrateringBrokers')"
                                          @change="(v,l)=>basicInfo.selectedBrokerCompany = l" />
                              </div>
                            </div>
                            <sp-radio :width="12" label-position="right" disabled :value="3" class="mg-t-10">
                              <div class="pd-l-10">{{ $l('SearchAndFilterSomeCharteringBrokers') }}</div>
                            </sp-radio>
                          </sp-radio-group>
                        </div>
                        <div class="flex-33 flex-jc-end pd-l-30">
                          <SpButton type="warn" width="200" height="54" to="selectCharteringBrokers"> {{ $l('BrowseAllAndSelect') }} </SpButton>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 公用部分 -->
                <div>
                  <div v-triangle class="border-box flex-al-center mg-t-20">
                    <span class="flex-10  text-left">{{ $l('From') }}</span>
                    <div class="flex-1 pd-r-30">
                      <SpSelect v-model="basicInfo.contactIds" class="font-12-select" width="1" multi-select type="gray" name="contactIds">
                        <SpSelectOption v-for="employeeDetail in employeeList"
                                        :label="employeeDetail.employee.fullName"
                                        :value="employeeDetail.employee.userId" />
                      </SpSelect>
                    </div>

                    <div style="width: 300px">
                      <p class="sp-color-1" style="margin-top: 0; margin-bottom: 5px"> {{ $l('WelcomeToContactUs') }} </p>
                      <sp-radio v-model="basicInfo.privacyPolicy" :width="12" label-position="right" name="privacyPolicy" :value="1" class="mg-t-10">
                        <div class="pd-l-10 sp-color-1">{{ $l('through Broker only') }}</div>
                      </sp-radio>
                    </div>
                  </div>
                  <div class="mg-t-20">
                    <el-scrollbar height="400px" width="1" style="box-shadow: 0 0 3px rgba(0,0,0,0.3)">
                      <div class="flex-al-start flex-jc-start">
                        <div v-for="(callingCard, index) in callingCards" :key="index" class="flex-50 mg-b-20 mg-t-20">
                          <NewCallingCard v-if="callingCard" :size="12" :per="callingCard.per" :dept="callingCard.dept" :s-com="callingCard.sCom" />
                        </div>
                      </div>
                    </el-scrollbar>
                  </div>
                </div>
              </div>
            </div>
          </sp-card>
        </div>
        <div class="flex-47 right-side">
          <div class="flex-jc-end">
            <SpButton type="primary" circle="4" width="239" :height="60" html-type="submit" @click="submitTo('match')">
              <div class="font12" style="margin-top: 5px; width: 100%">{{ $l('Send/Submit') }}</div>
              <div class="font12" style="margin-top: -20px">（To match result）</div>
            </SpButton>
            <SpButton type="primary" circle="4" width="239" :height="60" class="mg-l-20" html-type="submit" @click="submitTo('order')">
              <span class="font12" style="margin-top: 5px; width: 100%">{{ $l('Send/Submit') }}</span>
              <span class="font12" style="margin-top: -20px">（To all cargo order）</span>
            </SpButton>
            <SpButton class="mg-l-20" circle="4" type="back" :width="170" :height="60"><span class="">{{ $L('back') }}</span></SpButton>
          </div>

          <div class="mg-t-10 sp-color-bg-4" style="padding-left: 27px; padding-top: 20px; padding-right: 8px; padding-bottom: 30px">
            <div class="order-list-panel">
              <div v-for="(order, id, index) in ordersInfo" :key="index" class="flex-al-start flex-jc-bt order-item">
                <div class="font-bold number sp-color-1"> {{ new Array(3).join('0') + (index+1).toString().slice(-3) }}</div>
                <div class="select">
                  <SpSelect v-model="basicInfo.tagIds[id]" :height="20" class="" :width="100"
                            type="bottomBorder2" checked-icon="triangle"
                            select-icon-color="#EEB336"
                            :show-clear="false" :text-style="{fontSize: '14px', textAlign: 'left', paddingRight: '0px', paddingLeft: '0px', textIndent: '0px'}" :need-search="false" strategy="fixed">
                    <SpSelectOption v-for="(tag, index) in basicInfo.orderTags" :key="index" class="" font-size="14px" :label="tag.label" :value="tag.value" />
                  </SpSelect>
                </div>
                <div class="flex-1 order-info text-left">
                  {{ order.f }} <span class="icon-pointer iconfont mg-l-10 mg-r-10 sp-color-14" /> {{ order.e }}
                </div>
                <div>
                  <SpButton type="warn" width="59" height="28" @click="toShowFullTerms(id)"> {{ $l('F terms') }} </SpButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SpForm>
  </div>
  <FullTerm :show="showFullTermDialog" :order-id="checkId" @close="showFullTermDialog = false" />
</template>

<script type="text/ecmascript-6">
import { ref, reactive, computed } from 'vue'
import spCard from '@/components/common/SpCard'
import spRadio from '@/components/common/SpRadio'
import spRadioGroup from '@/components/common/SpRadioGroup'
import SpSelect from '@/components/common/SpSelect'
import SpSelectOption from '@/components/common/SpSelectOption'
import NewCallingCard from '@/components/common/NewCallingCard.vue'
import SpButton from '@/components/common/SpButton.vue'

import {
  getOrderTagApi
} from '@/request/APIs/co'
import { useRoute, useRouter } from 'vue-router'
import { getCompanyByClass, getEmployeeListNormalDetailApi } from '@/request/APIs/company'
import _forEach from 'lodash/forEach'
import SpForm from '@/components/common/SpForm'
import SpMessage from '@/components/common/SpMessage'
import { useStore } from 'vuex'

import FullTerm from '@/components/common/dialog/FullTerm'
import _cloneDeep from 'lodash/cloneDeep'
import _difference from 'lodash/difference'
import { orderTctPublishApi } from '../../../../request/APIs/boAndOp'

export default {
  name: 'TctCargoOrderPublish',

  nameSpace: 'cargoOwner.cargoOrders.CargoOrdersPublishing',

  components: {
    SpForm,
    spCard,
    spRadio,
    spRadioGroup,
    SpSelect,
    SpSelectOption,
    NewCallingCard,
    SpButton,
    FullTerm
  },

  props: {
  },

  setup (props, ctx) {
    const submitToRouter = ref('')
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const showFullTermDialog = ref(false)
    const orderId = route.query.id

    const ordersInfo = ref(JSON.parse(route.query.info))
    const ordersIdArr = ref(Object.keys(JSON.parse(route.query.info)))

    const ordersList = computed(() => {
      const arrInfo = Object.values(JSON.parse(route.query.info))
      const arr = []
      return arrInfo
    })

    const employeeList = ref([])
    getEmployeeListNormalDetailApi().then(res => {
      employeeList.value = res.data
      basicInfo.contactIds = [employeeList.value[0].employee.userId]
    })
    // 组装名片
    const callingCards = computed(() => {
      const employees = employeeList.value.filter(employeeDetail => basicInfo.contactIds.includes(employeeDetail.employee.userId))
      const employeesCallingCards = []

      if (employees.length > 0) {
        employees.forEach(e => {
          employeesCallingCards.push({
            per: e.employee,
            dept: e.department,
            sCom: e.department.company
          })
        })
      }
      return employeesCallingCards
    })

    const basicInfo = reactive({
      matchFilter: '0', // 'AllShipowners',
      filterDetail: '',
      companyOption: '',

      selectedCountry: [],
      privacyPolicy: null, // 1（AA），船货双方只能通过broker、op联系； 2（AB），船货双方可直接联系
      isAllOperators: 1,
      isAllBroker: 1,

      contactIds: [],
      orderTags: [],
      tagIds: {}
    })
    // 获取货盘标记
    getOrderTagApi().then(res => {
      if (res.code === 1) {
        basicInfo.orderTags = Object.values(res.data).map(item => ({ value: item.id, label: item.name }))
        _forEach(ordersIdArr.value, (id) => {
          basicInfo.tagIds[id] = basicInfo.orderTags[0].value
        })
      }
    })

    const emId = store.state.user.user.employerId
    getCompanyByClass({ class: 'shipowner', page: 1 }).then(res => {
      basicInfo.companyOptions = res.data.data.filter(item => item.employerId !== emId).map(item => ({
        value: item.id,
        label: item.name
      }))
    })
    getCompanyByClass({ class: 'broker', page: 1 }).then(res => {
      basicInfo.brokerCompanyOptions = res.data.data.filter(item => item.employerId !== emId).map(item => ({
        value: item.id,
        label: item.name
      }))
    })

    getCompanyByClass({ class: 'operator', page: 1 }).then(res => {
      basicInfo.opCompanyOptions = res.data.data.filter(item => item.employerId !== emId).map(item => ({
        value: item.id,
        label: item.name
      }))
    })

    const submitTo = (type) => {
      submitToRouter.value = type
    }
    const submit = (form) => {
      const methods = []
      const vArr = _cloneDeep(ordersIdArr.value)
      _forEach(ordersIdArr.value, (orderId, index) => {
        let formData = null
        formData = {
          orderId: orderId,
          filterType: '',
          brokerCorps: ['*'],
          privacyPolicy: parseInt(form.data.privacyPolicy) === 1 ? form.data.privacyPolicy : 2,
          contactIds: form.data.contactIds || basicInfo.contactIds,
          tagId: basicInfo.tagIds[orderId]
        }
        methods.push(orderTctPublishApi(formData).then((res) => {
          return formData
        }))
      })
      const errorIds = []
      Promise.all(methods.map(promise => promise.catch(error => ({ error })))).then(results => {
        const errors = results.filter(result => result.error)
        const data = results.filter(result => !result.error)

        if (errors.length > 0) {
          const successIds = data.map(item => item.voyageId)
          const errorIds = _difference(ordersIdArr.value, successIds)
          const info = {}
          _forEach(errorIds, id => {
            info[id] = ordersInfo.value[id]
          })
          ordersList.value = Object.values(info)
          ordersIdArr.value = Object.keys(info)
          ordersInfo.value = info
          router.push({
            name: 'tctCargoOrdersPublishing',
            query: {
              info: JSON.stringify(info)
            }
          })
        } else {
          SpMessage.success('Published!')
          if (submitToRouter.value === 'match') {
            router.push({
              name: 'tmatch',
              query: {
                type: 'weight',
                baseId: ordersIdArr.value[0]
              }
            })
          } else {
            router.push({
              name: 'allTctCargoOrders'
            })
          }
        }
      })
    }

    const checkId = ref({})
    const toShowFullTerms = (id) => { // 获取货盘full terms
      showFullTermDialog.value = true
      checkId.value = id
    }
    return {
      employeeList,
      callingCards,
      basicInfo,

      orderId,
      submit,

      submitTo,

      showFullTermDialog,
      toShowFullTerms,
      ordersInfo,
      ordersIdArr,
      ordersList,
      checkId
    }
  }

}
</script>

<style scoped lang="less">
.CargoOrdersPublishing{
  .order-list-panel {
    font-size: 12px;
    .order-item{
      &:first-child {
        .order-info{
          border-top: 1px solid #E5E5E5;
        }
      }
      min-height: 60px;
      .order-info{
        margin:  0 6px;
        padding-top: 10px;
        padding-left: 10px;
        padding-right: 10px;
        padding-bottom: 10px;
        min-height: 60px;
        box-sizing: border-box;
        line-height: 20px;
        border-bottom: 1px dashed #9AC6CD;
        border-left: 1px solid #E5E5E5;
        border-right: 1px solid #E5E5E5;
      }

      .number{
        width: 40px;
        padding-top: 14px;
        text-align: left;
      }
      .select{
        padding-top: 10px;
        width: 100px;
      }
    }
  }
  .bg-panel {
    background: #f6f6f6;
    color: #000000;
    padding: 11px 12px;
    box-sizing: border-box;
    cursor: not-allowed;
    min-height: 64px;
  }
  min-width: 1865px;
  .bg-gray{
    background-color: rgba(246, 246, 246, 0.5) !important;
  }
  .three-dimensional{
    min-width: 849px;
    .top {
      position: relative;
      left: 21px;
      top: 9px;
      width: 96%;
      height: 16px;
      background-color: #ECECEC;
      opacity: 0.5;
      transform: skewX(70deg);
    }
    .left {
      background-color: #ECECEC;
      width: 42px;
      transform: skewY(19deg);
      position: relative;
      height: 123px;
      top: -3px;
    }
  }
  .border-div{
    border: 1px solid #F0A201;
    line-height: 30px;
    width: 100%;
  }
  .content {
    padding: @gap @gap @gap*3 @gap;

    .card-content {
      padding: @gap;
      .radio-label{
        font-size: 12px;
        font-family: Arial;
        font-weight: normal;
        line-height: 14px;
      }
      .selected-charterers{
        margin:@gap 0 0 @gap;
        padding:@gap;
        .pannel{
          min-height:@gap*5;
          overflow: hidden;
          padding: 20px 10px;
          .selected-item{
            border: 1px solid gray;
            padding: 4px;
            border-radius: 4px;
            display: inline-flex;
            align-items: center;
            margin-right: 20px;
            margin-bottom: 10px;
          }
        }
        .white-pannel{
          box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
        }
      }
      .folder-icon{
        .icon{
          transition: 0.3s;
          transform: rotate(90deg);
        }
        .icon-folded{
          transform: rotate(270deg);
        }
      }
    }
  }
  .right-side{
    padding-top:@gap;
    .item{
      >*:first-child{
        flex:1 1 25%;
        box-sizing: border-box;
        padding-right: @gap;
        text-align: right;
      }
      >*:nth-child(2){
        flex:1 1 75%;
      }
    }
    .item-gap{
      margin: 10px 0;
    }
  }
}
</style>

<style>
.SpChoose.cusSpChoose label {
  align-items: flex-start !important;
}
.cusSpChoose.no-label label .label{
  display: none;
}
</style>
